"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.create = void 0;
const tslib_1 = require("tslib");
const eth_sig_util_1 = require("@metamask/eth-sig-util");
const helpers_1 = require("../chat/helpers");
const constants_1 = require("../constants");
const helpers_2 = require("../helpers");
const helpers_3 = require("../helpers");
const create = (options) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    const { env = constants_1.default.ENV.PROD, account = null, signer = null } = options || {};
    if (account == null && signer == null) {
        throw new Error(`At least one from account or signer is necessary!`);
    }
    const wallet = (0, helpers_1.getWallet)({ account, signer });
    const address = yield (0, helpers_1.getAccountAddress)(wallet);
    if (!(0, helpers_2.isValidETHAddress)(address)) {
        throw new Error(`Invalid address!`);
    }
    const keyPairs = yield (0, helpers_1.generateKeyPair)();
    let walletPublicKey;
    if ((_a = wallet === null || wallet === void 0 ? void 0 : wallet.signer) === null || _a === void 0 ? void 0 : _a.privateKey) {
        // get metamask specific encryption public key
        walletPublicKey = (0, eth_sig_util_1.getEncryptionPublicKey)((_b = wallet === null || wallet === void 0 ? void 0 : wallet.signer) === null || _b === void 0 ? void 0 : _b.privateKey.substring(2));
    }
    else {
        // wallet popup will happen to get encryption public key
        walletPublicKey = yield (0, helpers_3.getPublicKey)(wallet);
    }
    const encryptedPrivateKey = (0, helpers_2.encryptWithRPCEncryptionPublicKeyReturnRawData)(keyPairs.privateKeyArmored, walletPublicKey);
    const caip10 = (0, helpers_2.walletToPCAIP10)(address);
    console.log(encryptedPrivateKey);
    const body = {
        user: caip10,
        wallet,
        publicKey: keyPairs.publicKeyArmored,
        encryptedPrivateKey: JSON.stringify(encryptedPrivateKey),
        encryptionType: encryptedPrivateKey.version,
        env
    };
    return (0, helpers_1.createUserService)(body);
});
exports.create = create;
//# sourceMappingURL=createUser.js.map